export function hasAdQualityAccess(id?: number): boolean {
  if (process.env.REACT_APP_ENV === 'production' && id === 17160724) {
    return true;
  } else if ((process.env.REACT_APP_ENV === 'test' || process.env.REACT_APP_ENV === 'staging') && (id === 204461 || id === 279554782)) {
    return true;
  }
  return false;
}
